/**
 * Pipe Fitting Tool - Fitting Placement
 * 
 * Places pipe fittings (Elbows, Tees, etc.).
 */

import { v4 as uuidv4 } from 'uuid';
import { Element } from '../core/types';
import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import * as THREE from 'three';

export interface PipeFittingGeometryData {
    position: [number, number, number];
    rotation: number;
}

export interface PipeFittingElement extends Element {
    category: 'Pipe Fittings';
    geometryData: PipeFittingGeometryData;
}

export class PipeFittingTool extends BaseTool {
    id = 'pipe_fitting';
    name = 'Pipe Fitting';
    cursor = 'crosshair';

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const point = this.getIntersection(event);
        if (!point) return;

        const snapped = this.snapToGrid(point);
        this.createFitting(snapped);
    }

    onPointerMove(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        const point = this.getIntersection(event);
        if (point) {
            const snapped = this.snapToGrid(point);
            this.context.appStore.setToolPreview({
                type: 'fitting_pipe',
                position: snapped
            });
        }
    }

    onPointerUp(_event: ThreeEvent<PointerEvent>): void { }

    private createFitting(point: THREE.Vector3) {
        if (!this.context) return;

        const geometryData: PipeFittingGeometryData = {
            position: [point.x, point.y, point.z],
            rotation: 0
        };

        const fitting: PipeFittingElement = {
            id: uuidv4(),
            category: 'Pipe Fittings',
            type: 'Standard Elbow - Generic',
            parameters: {
                'Size': '100 mm',
                'Angle': '90°'
            },
            constraints: [],
            geometryData
        };

        this.context.bimStore.addElement(fitting);
    }
}
